import triggerTracking from '@blueprint/tracking';
import { TRACKING_EVENT } from 'listing-details/constants';

const VALIDATION_CATEGORY = 'Form Validation';
const ERROR_ACTION = 'Field error';

export const trackFullNameError = (errorMessage = '') => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: VALIDATION_CATEGORY,
        eventAction: ERROR_ACTION,
        eventLabel: `name_${errorMessage}`
    });
};

export const trackEmailError = (errorMessage = '') => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: VALIDATION_CATEGORY,
        eventAction: ERROR_ACTION,
        eventLabel: `email_${errorMessage}`
    });
};

export const trackPhoneError = (errorMessage = '') => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: VALIDATION_CATEGORY,
        eventAction: ERROR_ACTION,
        eventLabel: `phone_${errorMessage}`
    });
};

export const trackPostcodeError = (errorMessage = '') => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: VALIDATION_CATEGORY,
        eventAction: ERROR_ACTION,
        eventLabel: `postcode_${errorMessage}`
    });
};

export const trackSituationError = (errorMessage = '') => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: VALIDATION_CATEGORY,
        eventAction: ERROR_ACTION,
        eventLabel: `situation_${errorMessage}`
    });
};

export const trackSubmissionErrors = (errorList: Array<string>) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: VALIDATION_CATEGORY,
        eventAction: 'Submission error',
        eventLabel: errorList.join('|'),
        eventValue: errorList.length
    });
};

export const trackShowCaptcha = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'enquiry',
        eventAction: 'shown',
        eventLabel: 'captcha',
        eventNonInteraction: true
    });
};
